// extracted by mini-css-extract-plugin
module.exports = {"root":"CasinoGamePage_root__fa95K","bodyFullscreen":"CasinoGamePage_bodyFullscreen__Tmhrx","loading":"CasinoGamePage_loading__LAtuc"};